import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=5238f05a&scoped=true&"
import script from "./addTemplate.vue?vue&type=script&lang=js&"
export * from "./addTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=5238f05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238f05a",
  null
  
)

export default component.exports